export const en = {
    'error-message': 'The request failed, please try again later.',
    'success-message':
        "Thank you for sharing your feedback about your experience with the expert! We have sent your review for moderation. After moderation, it can be published on the expert's page and used to calculate their rating."
};
